import { messageBoxSuccess, messageBoxError } from './message-box';

export default class FormEditPersonal {

  private form: HTMLFormElement | null;
  private passwordInputField: HTMLInputElement | null;
  private mailInputField: HTMLInputElement | null;
  private submitButton: HTMLButtonElement | null;
  private passwordContainer: NodeListOf<HTMLElement> | null;


  init() {
    this.cacheElements();
    this.bindings();
  }

  private cacheElements() {
    this.form = document.querySelector('.js-form-edit-personal');
    if(this.form) {
      this.passwordInputField = this.form.querySelector('input[type="password"]');
      this.mailInputField = this.form.querySelector('input[type="email"]');
      this.submitButton = this.form.querySelector('button[type="submit"]');
      this.passwordContainer = this.form.querySelectorAll('.js-form-edit-personal__password-toggle');
    }
  }

  private bindings() {

    if(this.mailInputField) {
      this.mailInputField.addEventListener('input', () => {
        if(this.mailInputField?.value != this.mailInputField?.dataset.origin) {
          this.passwordContainer?.forEach( (container) => {
            container.classList.remove('is-hidden');
            if(this.passwordInputField) {
              this.passwordInputField.required = true;
              this.passwordInputField.addEventListener('input', this.handlePasswordValidation.bind(this) );
            }
            if(this.submitButton) {
              this.submitButton.disabled = true;
            }
          });
        }else {
          this.passwordContainer?.forEach( (container) => {
            container.classList.add('is-hidden');
            if(this.passwordInputField) {
              this.passwordInputField.required = false;
              this.passwordInputField.removeEventListener('input', this.handlePasswordValidation.bind(this));
              this.passwordInputField.value = '';
            }
            if(this.submitButton) {
              this.submitButton.disabled = false;
            }
          });
        }
      });
    }
  }

  private handlePasswordValidation() {
    if(this.passwordInputField?.value == '' || !this.passwordInputField?.value.match(/^\S+$/)) {
      if(this.passwordInputField) {
        this.passwordInputField.classList.add('has-error');
      }
      if(this.submitButton) {
        this.submitButton.disabled = true;
      }
    }else {
      this.passwordInputField?.classList.remove('has-error');
      if(this.submitButton) {
        this.submitButton.disabled = false;
      }
    }
  }
}
